'use strict';

function applyContentOptions(target) {
  // CONTENT

  /** @prop {string} [content.transactionCode] Custom unique code to identify the view. */
  target['content.transactionCode'] = undefined;

  /** @prop {string} [content.resource] URL/path of the current media resource. */
  target['content.resource'] = undefined;

  /** @prop {boolean} [content.isLive] True if the content is live false if VOD. */
  target['content.isLive'] = undefined;

  /** @prop {boolean} [content.isLive.noSeek] True if the player seeks automatically when resumed or ending buffer. Only for live content. False by default */
  target['content.isLive.noSeek'] = false;

  /** @prop {boolean} [content.isLive.noMonitor] True if the player returns non consistent values for the playhead on live, so playhead monitor wont work to detect buffers and seeks. False by default. */
  target['content.isLive.noMonitor'] = false;

  /** @prop {string} [content.title] Title of the media. */
  target['content.title'] = undefined;

  /** @prop {string} [content.program] Secondary title of the media */
  target['content.program'] = undefined;

  /** @prop {number} [content.duration] Duration of the media. */
  target['content.duration'] = undefined;

  /** @prop {number} [content.fps] Frames per second of the content in the current moment. */
  target['content.fps'] = undefined;

  /** @prop {number} [content.segmentDuration] Video segment length in milliseconds. */
  target['content.segmentDuration'] = undefined;

  /** @prop {number} [content.bitrate] Bitrate of the content in bits per second. */
  target['content.bitrate'] = undefined;

  /** @prop {number} [content.totalBytes] Total downloaded bytes of the content. */
  target['content.totalBytes'] = undefined;

  /** @prop {bool} [content.sendTotalBytes] Additionaly report totalbytes or not, default false. */
  target['content.sendTotalBytes'] = false;

  /** @prop {number} [content.throughput] Throughput of the client bandwith in bits per second. */
  target['content.throughput'] = undefined;

  /** @prop {string} [content.rendition] Name of the current rendition of the content. */
  target['content.rendition'] = undefined;

  /**
   * @prop {string} [content.cdn]
   * Codename of the CDN where the content is streaming from.
   * */
  target['content.cdn'] = undefined;

  /** @prop {string} [content.cdnNode] CDN node id */
  target['content.cdnNode'] = undefined;

  /**
   * @prop {number} [content.cdnType] CDN node content access type
   * It defines if the content request hits the cache or not
   * TCP_HIT / HIT: 1
   * TCP_MISS / MISS: 2
   * TCP_MEM_HIT: 3
   * TCP_IMS_HIT: 4
   */
  target['content.cdnType'] = undefined;

  /**
   * @prop {object} [content.metadata]
   * Item containing mixed extra information about the content like: director, parental rating,
   * device info or the audio channels.This object may store any serializable key:value info.
   */
  target['content.metadata'] = {};

  /**
   * @prop {object} [content.metrics]
   * Item containing metrics in json format. Reported every ping if the values change
   */
  target['content.metrics'] = {};

  /** @prop {string} [content.streamingProtocol] Name of the streaming media protocol.
   * Can be:
   *   - HDS (Adobe HDS)
   *   - HLS (Apple HLS)
   *   - MSS (Microsoft Smooth Streaming)
   *   - DASH (MPEG-DASH)
   *   - RTMP (Adobe RTMP)
   *   - RTP (RTP)
   *   - RTSP (RTSP)
   *   - MULTICAST (Multicast)
   *   - DVB (DVB)
   *   - DVBC (DVB-C)
   *   - DVBT (DVB-T)
   *   - DVBT2 (DVB-T2)
   */
  target['content.streamingProtocol'] = undefined;

  /** @prop {string} [content.transportFormat] Name of the transport format.
   * Can be:
   *   - TS (MPEG-2 TS)
   *   - MP4 (Fragmented MP4)
   */
  target['content.transportFormat'] = undefined;

  /** @prop {number} [content.package] Package of the media. */
  target['content.package'] = undefined;

  /** @prop {number} [content.saga] Saga of the media. */
  target['content.saga'] = undefined;

  /** @prop {number} [content.tvShow] TV Show of the media. */
  target['content.tvShow'] = undefined;

  /** @prop {number} [content.season] Season of the media. */
  target['content.season'] = undefined;

  /** @prop {number} [content.episodeTitle] Episode title of the media. */
  target['content.episodeTitle'] = undefined;

  /** @prop {number} [content.channel] Channel name of the media. */
  target['content.channel'] = undefined;

  /** @prop {number} [content.id] ID of the media. */
  target['content.id'] = undefined;

  /** @prop {number} [content.imdbId] IMDB id of the media. */
  target['content.imdbId'] = undefined;

  /** @prop {number} [content.gracenoteId] Gracenote id of the media. */
  target['content.gracenoteId'] = undefined;

  /** @prop {number} [content.type] Type of the media. */
  target['content.type'] = undefined;

  /** @prop {number} [content.genre] Genre of the media. */
  target['content.genre'] = undefined;

  /** @prop {number} [content.language] Language of the media. */
  target['content.language'] = undefined;

  /** @prop {boolean} [content.autodetect.language] Auto detect change languages value. */
  target['content.autodetect.language'] = true;

  /** @prop {number} [content.subtitles] Subtitles of the media. */
  target['content.subtitles'] = undefined;

  /** @prop {boolean} [content.autodetect.subtitles] Auto detect change subtitles value. */
  target['content.autodetect.subtitles'] = true;

  /** @prop {number} [content.contractedResolution] Contracted Resolution of the media. */
  target['content.contractedResolution'] = undefined;

  /** @prop {number} [content.cost] Cost of the media. */
  target['content.cost'] = undefined;

  /** @prop {number} [content.price] Price of the media. */
  target['content.price'] = undefined;

  /** @prop {number} [content.playbackType] Type of the media. Can be Vod, Live, catch-up or offline */
  target['content.playbackType'] = undefined;

  /** @prop {number} [content.drm] DRM of the media. */
  target['content.drm'] = undefined;

  // Encoding

  /** @prop {number} [content.encoding.videoCodec] Video codec of the media. */
  target['content.encoding.videoCodec'] = undefined;

  /** @prop {number} [content.encoding.audioCodec] Audio codec of the media. */
  target['content.encoding.audioCodec'] = undefined;

  /** @prop {number} [content.encoding.codecSettings] Codec settings of the media. */
  target['content.encoding.codecSettings'] = undefined;

  /** @prop {number} [content.encoding.codecProfile] Codec profile of the media. */
  target['content.encoding.codecProfile'] = undefined;

  /** @prop {number} [content.encoding.containerFormat] Container format of the media. */
  target['content.encoding.containerFormat'] = undefined;

  // EXTRAPARAMS // CUSTOM DIMENSIONS

  /** @prop {object} [content.customDimensions] Custom dimensions object. */
  target['content.customDimensions'] = {};

  /** @prop {string} [content.customDimension.1] Custom parameter 1. */
  target['content.customDimension.1'] = undefined;

  /** @prop {string} [content.customDimension.2] Custom parameter 2. */
  target['content.customDimension.2'] = undefined;

  /** @prop {string} [content.customDimension.3] Custom parameter 3. */
  target['content.customDimension.3'] = undefined;

  /** @prop {string} [content.customDimension.4] Custom parameter 4. */
  target['content.customDimension.4'] = undefined;

  /** @prop {string} [content.customDimension.5] Custom parameter 5. */
  target['content.customDimension.5'] = undefined;

  /** @prop {string} [content.customDimension.6] Custom parameter 6. */
  target['content.customDimension.6'] = undefined;

  /** @prop {string} [content.customDimension.7] Custom parameter 7. */
  target['content.customDimension.7'] = undefined;

  /** @prop {string} [content.customDimension.8] Custom parameter 8. */
  target['content.customDimension.8'] = undefined;

  /** @prop {string} [content.customDimension.9] Custom parameter 9. */
  target['content.customDimension.9'] = undefined;

  /** @prop {string} [content.customDimension.10] Custom parameter 10. */
  target['content.customDimension.10'] = undefined;

  /** @prop {string} [content.customDimension.11] Custom parameter 11. */
  target['content.customDimension.11'] = undefined;

  /** @prop {string} [content.customDimension.12] Custom parameter 12. */
  target['content.customDimension.12'] = undefined;

  /** @prop {string} [content.customDimension.13] Custom parameter 13. */
  target['content.customDimension.13'] = undefined;

  /** @prop {string} [content.customDimension.14] Custom parameter 14. */
  target['content.customDimension.14'] = undefined;

  /** @prop {string} [content.customDimension.15] Custom parameter 15. */
  target['content.customDimension.15'] = undefined;

  /** @prop {string} [content.customDimension.16] Custom parameter 16. */
  target['content.customDimension.16'] = undefined;

  /** @prop {string} [content.customDimension.17] Custom parameter 17. */
  target['content.customDimension.17'] = undefined;

  /** @prop {string} [content.customDimension.18] Custom parameter 18. */
  target['content.customDimension.18'] = undefined;

  /** @prop {string} [content.customDimension.19] Custom parameter 19. */
  target['content.customDimension.19'] = undefined;

  /** @prop {string} [content.customDimension.20] Custom parameter 20. */
  target['content.customDimension.20'] = undefined;
}

module.exports = applyContentOptions;

